module.exports = __webpack_public_path__ + "static/media/terms_and_conditions_en.52b3f55b.pdf";